import React, { useLayoutEffect, useState } from 'react'
import uPlot from 'uplot'

/** Re-renders the consumer whenever the chart's x scale is set: DOM overlays
    project data coords through valToPos, which only moves on that hook. */
export const useXScaleRedraw = (
  uPlotRef: React.RefObject<uPlot | null>
): void => {
  const [, setVersion] = useState(0)
  useLayoutEffect(() => {
    const u = uPlotRef.current
    if (!u) return
    const handler = (_u: uPlot, key: string) => {
      if (key !== 'x') return
      setVersion((version) => version + 1)
    }
    u.hooks.setScale = u.hooks.setScale ?? []
    u.hooks.setScale.push(handler)
    return () => {
      if (u.hooks.setScale) {
        u.hooks.setScale = u.hooks.setScale.filter((hook) => hook !== handler)
      }
    }
  }, [uPlotRef])
}
